// Alternating Buchi Automaton -> Non-deterministic Buchi Automaton
"use strict";
var bfml_1 = require('./bfml');
var alt_1 = require('./alt');
function toNBA(aba) {
    var alphabet = aba.alphabet;
    // ALTのstate集合Sに対して，NBAのstateは(2^S)×(2^S)
    var states = [];
    var transition = {};
    var accepting = [];
    // 初期状態から始めるぞ
    var initial = aba.accepting.indexOf(aba.initial) >= 0 ? ";" + aba.initial : aba.initial + ";";
    var queue = [initial];
    while (queue.length > 0) {
        var ststr = queue.shift();
        if (ststr in transition) {
            continue;
        }
        // 文字列表現を配列に直す
        var _a = ststr.split(';', 2), q0str = _a[0], q1str = _a[1];
        var q0 = q0str.split(',').filter(function (v) { return !!v; });
        var q1 = q1str.split(',').filter(function (v) { return !!v; });
        states.push(ststr);
        var map = {};
        if (q0.length === 0) {
            // Reset mode
            accepting.push(ststr);
            for (var _i = 0, alphabet_1 = alphabet; _i < alphabet_1.length; _i++) {
                var a = alphabet_1[_i];
                var sss = [];
                for (var _b = 0, q1_1 = q1; _b < q1_1.length; _b++) {
                    var q = q1_1[_b];
                    var abamap = aba.transition[q];
                    var bfml = abamap[a];
                    var ss_1 = makeNextState(bfml, false);
                    sss.push(ss_1);
                }
                var ss = makeAnd(sss);
                // sssたちのandを取る感じで
                // できたのでmapに書き込む
                map[a] = ss.map(function (_a) {
                    var q0 = _a[0], q1 = _a[1];
                    return alt_1.util.uniq(q0).sort().join(',') + ';' + alt_1.util.uniq(q1).sort().join(',');
                });
                queue.push.apply(queue, map[a]);
            }
        }
        else {
            // Reset modeでない
            for (var _c = 0, alphabet_2 = alphabet; _c < alphabet_2.length; _c++) {
                var a = alphabet_2[_c];
                var sss = [];
                for (var _d = 0, q0_1 = q0; _d < q0_1.length; _d++) {
                    var q = q0_1[_d];
                    var abamap = aba.transition[q];
                    var bfml = abamap[a];
                    var ss_2 = makeNextState(bfml, false);
                    sss.push(ss_2);
                }
                for (var _e = 0, q1_2 = q1; _e < q1_2.length; _e++) {
                    var q = q1_2[_e];
                    var abamap = aba.transition[q];
                    var bfml = abamap[a];
                    var ss_3 = makeNextState(bfml, true);
                    sss.push(ss_3);
                }
                var ss = makeAnd(sss);
                map[a] = ss.map(function (_a) {
                    var q0 = _a[0], q1 = _a[1];
                    return alt_1.util.uniq(q0).sort().join(',') + ';' + alt_1.util.uniq(q1).sort().join(',');
                });
                queue.push.apply(queue, map[a]);
            }
        }
        transition[ststr] = map;
    }
    return {
        alphabet: alphabet,
        states: states,
        transition: transition,
        initial: initial,
        accepting: accepting,
    };
    // fever: resetモードでなくてQ1由来のstateのときの処理
    function makeNextState(bfml, fever) {
        // BFmlから次のstateを作る（MH84の方法で）
        if (bfml instanceof bfml_1.BExp) {
            var e = bfml.exp;
            // q0かq1のどちらかに入れる
            if (fever || aba.accepting.indexOf(e.hash) >= 0) {
                return [[[], [e.hash]]];
            }
            else {
                return [[[e.hash], []]];
            }
        }
        else if (bfml instanceof bfml_1.BConst) {
            if (bfml.value) {
                // trueは0個のandと同じなんだよ
                return [[[], []]];
            }
            else {
                // falseは行き先がない
                return [];
            }
        }
        else if (bfml instanceof bfml_1.BOr) {
            var ss1 = makeNextState(bfml.op1, fever);
            var ss2 = makeNextState(bfml.op2, fever);
            // or: nondeterministicに分岐
            return ss1.concat(ss2);
        }
        else if (bfml instanceof bfml_1.BAnd) {
            var ss1 = makeNextState(bfml.op1, fever);
            var ss2 = makeNextState(bfml.op2, fever);
            // universalな分岐のときは合併する
            return makeAnd([ss1, ss2]);
        }
        else {
            throw new Error('ぎゃあああああ');
        }
    }
    // recursiveに直積をとる
    function makeAnd(sss) {
        if (sss.length === 0) {
            return [[[], []]];
        }
        else {
            var ss = sss[0], sss2 = sss.slice(1);
            var ss2 = makeAnd(sss2);
            var result = [];
            for (var _i = 0, ss_4 = ss; _i < ss_4.length; _i++) {
                var _a = ss_4[_i], q0 = _a[0], q1 = _a[1];
                for (var _b = 0, ss2_1 = ss2; _b < ss2_1.length; _b++) {
                    var _c = ss2_1[_b], q2 = _c[0], q3 = _c[1];
                    result.push([q0.concat(q2), q1.concat(q3)]);
                }
            }
            return result;
        }
    }
}
exports.toNBA = toNBA;



/*****************
 ** WEBPACK FOOTER
 ** ./dist/nba.js
 ** module id = 27
 ** module chunks = 1
 **/


/*****************
 ** WEBPACK FOOTER
 ** ./dist/nba.js
 ** module id = 27
 ** module chunks = 1
 **/